import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import * as PriceActions from './prices.actions';
import * as _ from 'lodash';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api';
export const priceFeatureKey = 'prices';

export interface State {
  loaded: boolean;
  loading: boolean;
  prices: Array<contractmanagement_api.PriceListLocationDataListItem>;
  error?: Error | HttpErrorResponse;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  prices: []
};

export const reducer = createReducer(
  initialState,

  on(PriceActions.loadPrices, (state, action) => ({
    ...state,
    loading: true
  })),

  on(PriceActions.loadPricesSuccess, (state: State, action) => ({
    ...state,
    loaded: true,
    loading: false,
    prices: action.data,
    error: undefined
  })),

  on(PriceActions.loadPricesFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  }))
);
